import {
  Accordion,
  AccordionButton,
  AccordionItem,
  Avatar,
  Box,
  Card,
  CardHeader,
  Flex,
  Heading,
  Text,
  Image,
  AccordionPanel,
} from "@chakra-ui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { AiOutlineFundProjectionScreen, AiOutlineHome } from "react-icons/ai";
import {
  BsListTask,
  BsFingerprint,
  BsChatDots,
  BsGraphUpArrow,
  BsBuildings,
  BsColumnsGap,
} from "react-icons/bs";
import { SlCalender } from "react-icons/sl";
import { HiOutlineDocumentText } from "react-icons/hi";
import { FaCoins, FaFileExcel, FaIdeal } from "react-icons/fa";
import { IoIosArrowDropdown, IoIosArrowDropupCircle } from "react-icons/io";
import companylogo from "../assets/companylogo.png";
import { useEffect } from "react";
import { fetchAttendances, getUsers } from "../Redux/app/action";
import { GrUserManager } from "react-icons/gr";

const AdminSidebar = () => {
  const globalState = useSelector((store) => store.authentication.data.token);
  //console.log(globalState);
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUsers());
  }, [dispatch]);
  const id = useSelector((store) => store.authentication.users.id);
  const users = useSelector((store) => store.AppReducer.users);
  const filteredUser = users?.filter((obj) => obj._id === id) || [];

  const isActive = (pathname) => {
    return location.pathname === pathname;
  };

  const isPMSActive =
    location.pathname.startsWith("/project") ||
    location.pathname.startsWith("/admintask");
  const defaultIndex = isPMSActive ? [0] : [];

  useEffect(() => {
    dispatch(fetchAttendances());
  }, [dispatch]);
  const attendances = useSelector((state) => state.AppReducer.attendances);
  const empglobalState = useSelector((store) => store.authentication.users.id);
  const filteredData =
    attendances?.filter((obj) => obj.employee_id === empglobalState) || [];

  const reversedAttendances = [...filteredData].reverse();
  const attendance = reversedAttendances.find(
    (attendance) => attendance.employee_id === id
  );
  const getStatusColor = (status) => {
    return status === "Available" ? "green" : "red";
  };
  const statusColor = attendance ? getStatusColor(attendance.status) : "gray";
  return (
    <Box p={{ base: "none", md: 5 }} w={{ base: "100%", md: "15%" }}>
      <Box display={{ base: "none", sm: "block" }}>
        <Link to="/admin">
          <Box w={150}>
            <Image
              src={companylogo}
              width={{ base: "50%", sm: "50%", md: "50%" }}
              height="auto"
              objectFit="cover"
            />
          </Box>
        </Link>
        <br />
        <Link to="#">
          <Card
            maxW="md"
            bgGradient="linear(to-r, teal.300,  teal.100)"
            _hover={{ bgGradient: "linear(to-r, teal.100,  teal.400)" }}
          >
            <CardHeader>
              <Flex spacing="4">
                <Flex flex="1" gap="4" alignItems="center" flexWrap="wrap">
                  {/* <Avatar
                    name={globalState.first_name}
                    src={`https://develop-project-360.onrender.com/${filteredUser[0].path}`}
                    backgroundColor={"teal"}
                  /> */}
                  <Box
                    style={{
                      position: "relative",
                      display: "inline-block",
                    }}
                  >
                    <Avatar
                      name={globalState.first_name}
                      size="sm"
                      src={
                        filteredUser[0]
                          ? `https://develop-project-360.onrender.com/${filteredUser[0].path}`
                          : `https://develop-project-360.onrender.com/${globalState.path}`
                      }
                    />

                    <span
                      style={{
                        position: "absolute",
                        bottom: "-2px", // Adjust this value to position the status dot properly
                        right: "-2px", // Adjust this value to position the status dot properly
                        display: "inline-block",
                        width: "10px",
                        height: "10px",
                        borderRadius: "50%",
                        backgroundColor: statusColor,
                      }}
                    />
                  </Box>

                  <Box>
                    <Heading size="sm">{globalState.first_name}</Heading>
                    <Text textTransform={"capitalize"}>{globalState.role}</Text>
                  </Box>
                </Flex>
              </Flex>
            </CardHeader>
          </Card>
        </Link>
        <br />
        <br />
        <Heading size="md" fontWeight={"bold"} textAlign={"start"}>
          General
        </Heading>
        <br />
        <Accordion allowToggle lineHeight={8}>
          <Link to="/admin">
            <AccordionItem>
              <h2>
                <AccordionButton
                  _hover={{
                    fontWeight: "semibold",
                    color: isActive("/admin") ? "green" : "green",
                  }}
                  color={isActive("/admin") ? "green" : "inherit"}
                >
                  <AiOutlineHome />
                  <Box as="span" flex="1" textAlign="left" ml={3}>
                    Dashboard
                  </Box>
                </AccordionButton>
              </h2>
            </AccordionItem>
          </Link>
          <AccordionItem>
            {({ isExpanded }) => (
              <>
                <h2>
                  <AccordionButton
                    _hover={{ fontWeight: "semibold", color: "green" }}
                    color={isActive("/crm") ? "green" : "inherit"}
                  >
                    <FaCoins />
                    <Box as="span" flex="1" textAlign="left" ml={3}>
                      CRM
                    </Box>
                    {isExpanded ? (
                      <IoIosArrowDropupCircle />
                    ) : (
                      <IoIosArrowDropdown />
                    )}
                  </AccordionButton>
                </h2>

                <AccordionPanel pb={4}>
                  <Link to="/sheets">
                    <AccordionButton
                      _hover={{
                        fontWeight: "semibold",
                        color: isActive("/sheets") ? "green" : "green",
                      }}
                      color={isActive("/sheets") ? "green" : "inherit"}
                    >
                      <FaFileExcel />
                      <Box as="span" flex="1" textAlign="left" ml={3}>
                        Sheets
                      </Box>
                    </AccordionButton>
                  </Link>

                  <Link to="/leads">
                    <AccordionButton
                      _hover={{
                        fontWeight: "semibold",
                        color: isActive("/leads") ? "green" : "green",
                      }}
                      color={isActive("/leads") ? "green" : "inherit"}
                    >
                      <BsGraphUpArrow />
                      <Box as="span" flex="1" textAlign="left" ml={3}>
                        Leads
                      </Box>
                    </AccordionButton>
                  </Link>

                  <Link to="/deals">
                    <AccordionButton
                      _hover={{
                        fontWeight: "semibold",
                        color: isActive("/deals") ? "green" : "green",
                      }}
                      color={isActive("/deals") ? "green" : "inherit"}
                    >
                      <FaIdeal />
                      <Box as="span" flex="1" textAlign="left" ml={3}>
                        Deals
                      </Box>
                    </AccordionButton>
                  </Link>
                </AccordionPanel>
              </>
            )}
          </AccordionItem>

          <AccordionItem>
            {({ isExpanded }) => (
              <>
                <h2>
                  <AccordionButton
                    _hover={{ fontWeight: "semibold", color: "green" }}
                    color={isActive("/pms") ? "green" : "inherit"}
                  >
                    <AiOutlineFundProjectionScreen />
                    <Box as="span" flex="1" textAlign="left" ml={3}>
                      PMS
                    </Box>
                    {isExpanded ? (
                      <IoIosArrowDropupCircle />
                    ) : (
                      <IoIosArrowDropdown />
                    )}
                  </AccordionButton>
                </h2>

                <AccordionPanel pb={4}>
                  <Link to="/project">
                    <AccordionButton
                      _hover={{
                        fontWeight: "semibold",
                        color: isActive("/project") ? "green" : "green",
                      }}
                      color={isActive("/project") ? "green" : "inherit"}
                    >
                      <AiOutlineFundProjectionScreen />
                      <Box as="span" flex="1" textAlign="left" ml={3}>
                        Project
                      </Box>
                    </AccordionButton>
                  </Link>

                  <Link to="/admintask">
                    <AccordionButton
                      _hover={{
                        fontWeight: "semibold",
                        color: isActive("/admintask") ? "green" : "green",
                      }}
                      color={isActive("/admintask") ? "green" : "inherit"}
                    >
                      <BsListTask />
                      <Box as="span" flex="1" textAlign="left" ml={3}>
                        Task
                      </Box>
                    </AccordionButton>
                  </Link>
                </AccordionPanel>
              </>
            )}
          </AccordionItem>

          {/* <Accordion allowMultiple defaultIndex={defaultIndex}>
            <AccordionItem>
              {({ isExpanded }) => (
                <>
                  <h2>
                    <AccordionButton
                      _hover={{ fontWeight: "semibold", color: "green" }}
                      color={isPMSActive ? "green" : "inherit"}
                    >
                      <AiOutlineFundProjectionScreen />
                      <Box as="span" flex="1" textAlign="left" ml={3}>
                        PMS
                      </Box>
                      {isExpanded ? (
                        <IoIosArrowDropupCircle />
                      ) : (
                        <IoIosArrowDropdown />
                      )}
                    </AccordionButton>
                  </h2>

                  <AccordionPanel pb={4}>
                    <Link to="/project">
                      <AccordionButton
                        _hover={{ fontWeight: "semibold", color: "green" }}
                        color={isActive("/project") ? "green" : "inherit"}
                      >
                        <AiOutlineFundProjectionScreen />
                        <Box as="span" flex="1" textAlign="left" ml={3}>
                          Project
                        </Box>
                      </AccordionButton>
                    </Link>

                    <Link to="/admintask">
                      <AccordionButton
                        _hover={{ fontWeight: "semibold", color: "green" }}
                        color={isActive("/admintask") ? "green" : "inherit"}
                      >
                        <BsListTask />
                        <Box as="span" flex="1" textAlign="left" ml={3}>
                          Task
                        </Box>
                      </AccordionButton>
                    </Link>
                  </AccordionPanel>
                </>
              )}
            </AccordionItem>
          </Accordion> */}

          {/* <Link to="/admintask">
            <AccordionItem>
              <h2>
                <AccordionButton
                  _hover={{
                    fontWeight: "semibold",
                    color: isActive("/admintask") ? "green" : "green",
                  }}
                  color={isActive("/admintask") ? "green" : "inherit"}
                >
                  <BsListTask />
                  <Box as="span" flex="1" textAlign="left" ml={3}>
                    Task
                  </Box>
                </AccordionButton>
              </h2>
            </AccordionItem>
          </Link> */}
          {/* <Link to="/project">
            <AccordionItem>
              <h2>
                <AccordionButton
                  _hover={{
                    fontWeight: "semibold",
                    color: isActive("/project") ? "green" : "green",
                  }}
                  color={isActive("/project") ? "green" : "inherit"}
                >
                  <BsListTask />
                  <Box as="span" flex="1" textAlign="left" ml={3}>
                    Project
                  </Box>
                </AccordionButton>
              </h2>
            </AccordionItem>
          </Link> */}
          <AccordionItem>
            {({ isExpanded }) => (
              <>
                <h2>
                  <AccordionButton
                    _hover={{ fontWeight: "semibold", color: "green" }}
                    color={isActive("/hrms") ? "green" : "inherit"}
                  >
                    <BsColumnsGap />
                    <Box as="span" flex="1" textAlign="left" ml={3}>
                      HRMS
                    </Box>
                    {isExpanded ? (
                      <IoIosArrowDropupCircle />
                    ) : (
                      <IoIosArrowDropdown />
                    )}
                  </AccordionButton>
                </h2>

                <AccordionPanel pb={4}>
                  <Link to="/employees">
                    <AccordionButton
                      _hover={{
                        fontWeight: "semibold",
                        color: isActive("/employees") ? "green" : "green",
                      }}
                      color={isActive("/employees") ? "green" : "inherit"}
                    >
                      <GrUserManager />
                      <Box as="span" flex="1" textAlign="left" ml={3}>
                        Employees
                      </Box>
                    </AccordionButton>
                  </Link>

                  <Link to="/adminattendence">
                    <AccordionButton
                      _hover={{
                        fontWeight: "semibold",
                        color: isActive("/adminattendence") ? "green" : "green",
                      }}
                      color={isActive("/adminattendence") ? "green" : "inherit"}
                    >
                      <BsFingerprint />
                      <Box as="span" flex="1" textAlign="left" ml={3}>
                        Attendence
                      </Box>
                    </AccordionButton>
                  </Link>

                  <Link to="/admingenerateletters">
                    <AccordionButton
                      _hover={{
                        fontWeight: "semibold",
                        color: isActive("/admingenerateletters")
                          ? "green"
                          : "green",
                      }}
                      color={
                        isActive("/admingenerateletters") ? "green" : "inherit"
                      }
                    >
                      <HiOutlineDocumentText />
                      <Box as="span" flex="1" textAlign="left" ml={3}>
                        Generate Letters
                      </Box>
                    </AccordionButton>
                  </Link>
                </AccordionPanel>
              </>
            )}
          </AccordionItem>

          <Link to="/adminchat">
            <AccordionItem>
              <h2>
                <AccordionButton
                  _hover={{
                    fontWeight: "semibold",
                    color: isActive("/adminchat") ? "green" : "green",
                  }}
                  color={isActive("/adminchat") ? "green" : "inherit"}
                >
                  <BsChatDots />
                  <Box as="span" flex="1" textAlign="left" ml={3}>
                    Chats
                  </Box>
                </AccordionButton>
              </h2>
            </AccordionItem>
          </Link>
          {/* <Link to="/adminattendence">
            <AccordionItem>
              <h2>
                <AccordionButton
                  _hover={{
                    fontWeight: "semibold",
                    color: isActive("/adminattendence") ? "green" : "green",
                  }}
                  color={isActive("/adminattendence") ? "green" : "inherit"}
                >
                  <BsFingerprint />
                  <Box as="span" flex="1" textAlign="left" ml={3}>
                    Attendence
                  </Box>
                </AccordionButton>
              </h2>
            </AccordionItem>
          </Link> */}
          <Link to="/admincalender">
            <AccordionItem>
              <h2>
                <AccordionButton
                  _hover={{
                    fontWeight: "semibold",
                    color: isActive("/admincalender") ? "green" : "green",
                  }}
                  color={isActive("/admincalender") ? "green" : "inherit"}
                >
                  <SlCalender />
                  <Box as="span" flex="1" textAlign="left" ml={3}>
                    Calender
                  </Box>
                </AccordionButton>
              </h2>
            </AccordionItem>
          </Link>

          {/* <Link to="/employees">
            <AccordionItem>
              <h2>
                <AccordionButton
                  _hover={{
                    fontWeight: "semibold",
                    color: isActive("/employees") ? "green" : "green",
                  }}
                  color={isActive("/employees") ? "green" : "inherit"}
                >
                  <AiOutlineMail />
                  <Box as="span" flex="1" textAlign="left" ml={3}>
                    Employees
                  </Box>
                 
                </AccordionButton>
              </h2>
            </AccordionItem>
          </Link> */}
          <Link to="/companies">
            <AccordionItem>
              <h2>
                <AccordionButton
                  _hover={{
                    fontWeight: "semibold",
                    color: isActive("/companies") ? "green" : "green",
                  }}
                  color={isActive("/companies") ? "green" : "inherit"}
                >
                  <BsBuildings />
                  <Box as="span" flex="1" textAlign="left" ml={3}>
                    Companies
                  </Box>
                </AccordionButton>
              </h2>
            </AccordionItem>
          </Link>
          {/* <Link to="/admingenerateletters">
            <AccordionItem>
              <h2>
                <AccordionButton
                  _hover={{
                    fontWeight: "semibold",
                    color: isActive("/admingenerateletters")
                      ? "green"
                      : "green",
                  }}
                  color={
                    isActive("/admingenerateletters") ? "green" : "inherit"
                  }
                >
                  <HiOutlineDocumentText />
                  <Box as="span" flex="1" textAlign="left" ml={3}>
                    Generate Letters
                  </Box>
                  
                </AccordionButton>
              </h2>
            </AccordionItem>
          </Link> */}
        </Accordion>
      </Box>
    </Box>
  );
};

export default AdminSidebar;
